var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"searchText u-text-center"},[_c('p',{staticClass:"searchText__title searchText__title--sm"},[_vm._v(" 找不到「"+_vm._s(_vm.searchText)+"」 ")]),_c('p',{staticClass:"searchText__subtitle"},[_vm._v(" 請嘗試用不同拼法或關鍵字再搜尋一次。 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }